module.exports = __webpack_public_path__ + "static/media/MTN Logo.e29098e7.svg";